
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "__swiper": {
    "bundled": true
  }
}

/** client **/
import { _replaceAppConfig } from '#app/config'

// Vite - webpack is handled directly in #app/config
if (import.meta.dev && !import.meta.nitro && import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}
/** client-end **/

import cfg0 from "/builds/special/akinfeev/app/app.config.ts"
import cfg1 from "/builds/special/akinfeev/packages/base/app/app.config.ts"
import cfg2 from "/builds/special/akinfeev/packages/common/app/app.config.ts"
import cfg3 from "/builds/special/akinfeev/packages/team/app/app.config.ts"
import cfg4 from "/builds/special/akinfeev/packages/rules/app/app.config.ts"
import cfg5 from "/builds/special/akinfeev/packages/start/app/app.config.ts"
import cfg6 from "/builds/special/akinfeev/packages/final/app/app.config.ts"
import cfg7 from "/builds/special/akinfeev/packages/quiz/app/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, cfg1, cfg2, cfg3, cfg4, cfg5, cfg6, cfg7, inlineConfig)
